<script setup>
import {ref, watch} from 'vue'
import {useOrderLogsStore} from '@/stores/orderLogs'
import {useModalsStore} from '@/stores/modals'

const props = defineProps({
    item: Object
})

const orderLogsStore = useOrderLogsStore()
const modalsStore = useModalsStore()

const show = ref(false)

watch(() => props.item?.id, async (newId) => {
    if (!newId) {
        show.value = false
        return
    }
    const orderIds = await orderLogsStore.fetchOrderIds() || []
    show.value = orderIds.indexOf(newId) > -1
}, {immediate: true})

const openLogsModal = () => {
    modalsStore.show({
        componentName: 'OrdersLogsModal',
        obj: {orderId: props.item.id}
    })
}
</script>

<template>
    <button v-if="show" class="btn btn-light btn-sm" type="button" @click="openLogsModal">
        view
    </button>
</template>